
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { GetCategoriesByCommunityId, DeleteCategory} from '../../actions/categoryActions'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, IconButton, Modal } from '@material-ui/core';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import DeleteCategoryModal from './DeleteCategoryModal';


class CategoriesList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            selected: undefined
        };
    };


    handleDelete=(e,category)=>{


        this.setState({
            selected:category,
            open:true

        })
    }

    handleDeleteCategory =()=>{
        if(this.state.selected){
            this.props.DeleteCategory(this.state.selected._id);

        }

        this.setState({
            selected:undefined,
            open:false
        })
    }

    handleEditCategory=(e, cat)=>{
        if(cat && !cat.disableActions){
            this.props.onSelectCategory(cat)
        }
    }

    render() {
        return (
            <>
                <Grid item container xs={12}>

                    <Grid container className="titleEngageStyleHeadersBook" style={{ padding:'0px 10px' }} >
                        <Grid item container xs={11} alingItems='center'>
                            <Grid item xs={3} sm={2} style={{textAlign:'center'}}>Color</Grid>
                            <Grid item xs={3} sm={2}>Icon</Grid>
                            <Grid item xs={5} sm={8}>Name</Grid>
                        </Grid>
                      
                        <Grid item sm={1}></Grid>
                    </Grid>
                  



                    {
                        this.props.categoryData && this.props.categoryData.map(c=>{

                            return(
                                <Grid item container xs={12} className="categoryRow" key={`category_row_${c._id}`} alignItems='center' style={{cursor:(!c.disableActions)?'pointer':'auto'}} >
                                    <Grid item container xs={11} alignItems='center' onClick={(e)=>this.handleEditCategory(e,c)}>
                                        <Grid item container xs={3} sm={2} justify='center'>

                                            <Grid style={{width:'72px', height:'72px', backgroundColor:c.categoryColor, borderRadius:'16px'}}></Grid>
                                        </Grid>

                                        <Grid item xs={3} sm={2}>
                                            <img
                                                src={c.iconUrl}
                                                alt='icon'
                                                height='72px'
                                                width='110px'
                                            />
                                        </Grid>

                                        <Grid item xs={5} sm={8}>{c.name}</Grid>

                                    </Grid>
                                   
                                    <Grid item xs={1}>
                                        {
                                            (!c.disableActions) &&
                                            <IconButton onClick={(e)=>this.handleDelete(e,c)}>
                                                <FontAwesomeIcon
                                                    icon={faTrashAlt}
                                                    color='#c43740'
                                                    size='2x'
                                                />
                                            </IconButton>
                                        }
                
                                    </Grid>

                                </Grid>
                            )
                        })
                    }

                </Grid>

                <Modal
                    open={this.state.open}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ borderRadius: '16px' }}
                    onClose={() => this.setState({open:false, selected:undefined})}
                >
                    <DeleteCategoryModal
                        category={this.state.selected}
                        close={() =>this.setState({ open: false, selected:undefined })}
                        onDelete={this.handleDeleteCategory}
                    />

                </Modal>
                
            </>
        )
    }
}


function mapStateToProps(state) {
    const categoryData = (state.categoryReducer && state.categoryReducer.categoryData && Array.isArray(state.categoryReducer.categoryData)) ? state.categoryReducer.categoryData : [];


    return {
        categoryData
    }
};

export default connect(mapStateToProps, {GetCategoriesByCommunityId, DeleteCategory})(CategoriesList);
